import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { signout } from '../../actions/auth';

class Logout extends Component {
  componentDidMount() {
    const { dispatch, history } = this.props;
    dispatch(signout(() => history.push('/login')));
  }

  render() {
    return null;
  }
}

Logout.propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.shape({
    history: PropTypes.object,
  }).isRequired,
};
export default connect()(Logout);
